import { render, staticRenderFns } from "./rh_configuracao.vue?vue&type=template&id=5da66b57&scoped=true&"
import script from "./rh_configuracao.vue?vue&type=script&lang=js&"
export * from "./rh_configuracao.vue?vue&type=script&lang=js&"
import style0 from "./rh_configuracao.vue?vue&type=style&index=0&id=5da66b57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da66b57",
  null
  
)

export default component.exports